/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-02-04 19:14:12
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiAlign - align the cell to the position.
// rule: lt t rt l (left) center(default) r (right) lb b rb

@UITag.set()
export class uiAlign extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableHeaderCellContainer,
        EUITagTarget.TableBodyCellContainer,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Custom];
    allowNullRule: boolean = true; /// default to "center"

    /// set styles display: inherit / none
    parse(input: IUITagInput): IUITagResult {
        /// rule: lt t rt l (left) center(default) r (right) lb b rb
        const rule = this.parseRule(input) ?? "center";
        const { textAlign, verticalAlign } = alignmentMap[rule as string] || {};
        if (textAlign == null || verticalAlign == null) {
            console.error(
                `<uiAlign> unknown rule <${input.rule}>, should be ${Object.keys(
                    alignmentMap,
                ).join("/")}.`,
            );
            return {};
        }

        return {
            styles: {
                "text-align": textAlign,
                "vertical-align": verticalAlign,
            },
        };
    }
}

/// private helper
const alignmentMap: { [key: string]: { textAlign: string; verticalAlign: string } } = {
    lt: { textAlign: "left", verticalAlign: "top" },
    t: { textAlign: "center", verticalAlign: "top" },
    rt: { textAlign: "right", verticalAlign: "top" },
    l: { textAlign: "left", verticalAlign: "middle" },
    left: { textAlign: "left", verticalAlign: "middle" },
    center: { textAlign: "center", verticalAlign: "middle" },
    r: { textAlign: "right", verticalAlign: "middle" },
    right: { textAlign: "right", verticalAlign: "middle" },
    lb: { textAlign: "left", verticalAlign: "bottom" },
    b: { textAlign: "center", verticalAlign: "bottom" },
    rb: { textAlign: "right", verticalAlign: "bottom" },
};
